import type { GrupoDePermissoes } from './tipos';

/**
 * A chave Administrador e, sem ela, as caixas por módulo contratado (U-03). O
 * que quem está logado não pode conceder aparece desabilitado, com o motivo.
 */
export default function PermissoesDoUsuario({
  grupos,
  administrador,
  marcadas,
  bloqueioAdministrador,
  aoMudarAdministrador,
  aoMudarMarcadas,
}: {
  grupos: GrupoDePermissoes[];
  administrador: boolean;
  marcadas: Set<string>;
  bloqueioAdministrador: string | null;
  aoMudarAdministrador: (administrador: boolean) => void;
  aoMudarMarcadas: (marcadas: Set<string>) => void;
}) {
  const alternar = (slugs: string[], ligar: boolean) => {
    const proximo = new Set(marcadas);
    slugs.forEach((slug) => (ligar ? proximo.add(slug) : proximo.delete(slug)));
    aoMudarMarcadas(proximo);
  };

  return (
    <div>
      <label
        title={bloqueioAdministrador ?? undefined}
        className={`flex items-start gap-sm rounded-md border p-sm ${administrador ? 'border-accent bg-accent/5' : 'border-border bg-surface'} ${
          bloqueioAdministrador ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
        }`}
      >
        <input
          type="checkbox"
          checked={administrador}
          disabled={bloqueioAdministrador !== null}
          onChange={(evento) => aoMudarAdministrador(evento.target.checked)}
          className="mt-[3px] accent-accent"
        />
        <span>
          <span className="block text-[13px] font-bold text-ink">Administrador</span>
          <span className="block text-[12px] text-muted">
            {bloqueioAdministrador ?? 'Acesso a tudo o que a empresa contratou, inclusive o cadastro de usuários.'}
          </span>
        </span>
      </label>

      {!administrador && (
        <div className="mt-sm space-y-sm">
          {grupos.map((grupo) => {
            const concediveis = grupo.permissoes.filter((permissao) => permissao.pode_conceder).map((permissao) => permissao.slug);
            const todas = concediveis.length > 0 && concediveis.every((slug) => marcadas.has(slug));

            return (
              <fieldset key={grupo.modulo} className="rounded-md border border-border p-sm">
                <legend className="flex w-full items-center justify-between gap-sm px-xs">
                  <span className="text-[12px] font-bold text-ink">{grupo.nome}</span>
                  {concediveis.length > 0 && (
                    <button
                      type="button"
                      onClick={() => alternar(concediveis, !todas)}
                      className="text-[12px] font-bold text-accent hover:underline"
                    >
                      {todas ? 'desmarcar todas' : 'marcar todas'}
                    </button>
                  )}
                </legend>
                <div className="grid gap-[2px] sm:grid-cols-2">
                  {grupo.permissoes.map((permissao) => (
                    <label
                      key={permissao.slug}
                      title={permissao.pode_conceder ? undefined : 'Você não tem esta permissão para conceder.'}
                      className={`flex items-start gap-xs py-[2px] text-[13px] ${permissao.pode_conceder ? 'cursor-pointer text-ink' : 'cursor-not-allowed text-muted'}`}
                    >
                      <input
                        type="checkbox"
                        checked={marcadas.has(permissao.slug)}
                        disabled={!permissao.pode_conceder}
                        onChange={(evento) => alternar([permissao.slug], evento.target.checked)}
                        className="mt-[3px] accent-accent"
                      />
                      {permissao.rotulo}
                    </label>
                  ))}
                </div>
              </fieldset>
            );
          })}
        </div>
      )}
    </div>
  );
}
